module.exports = __webpack_public_path__ + "media/images/country_flags/er-96e3bd169c87af379fc84e661f02a5c1.png";